<template>
  <div class="app-container">
    <div class="box">
      <el-form label-width="80px" status-icon>
        <el-form-item label="起始时间">
          <el-date-picker
            v-model="month"
            type="month"
            placeholder="选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="存货分类">
          <el-select v-model="ClassId" filterable>
            <el-option v-for="item in classList" :key="item.ClassId" :label="item.ClassName" :value="item.ClassId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货编码">
           <el-select v-model="ProductId" filterable>
            <el-option v-for="item in productList" :key="item.ProductId" :label="item.ProductNo" :value="item.ProductId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="checked1"
            >移动平均法存货同一天先记入库再记出库</el-checkbox
          >
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="checked2">同步计算产品成本</el-checkbox>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="save">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";

export default {
  mixins: [curdMixins],
  data() {
    return {
      classApi: require('@/api/ba/class').default,
      api:require('@/api/stock/skCostBook').default,
      classList: [],
      productApi: require('@/api/ba/product').default,
      productList: [],
      month: "",
      ClassId: null,
      ProductId: null,
      checked1: false,
      checked2: false,
      data:{}
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      this.classApi.list({ClassType: 1}).then(res => {
        if(res.Code === 0){
          this.classList = res.Data;
        }
      })

      this.productApi.list({Status: 1}).then(res => {
        if(res.Code === 0){
          this.productList = res.Data
        }
      })
    },
    save(){
      this.data.YearMouth=this.month
      if(this.ClassId)
      this.data.IdChain=String(this.ClassId)
      if(this.ClassId)
      this.data.ProductNo=String(this.ClassId)
      this.data.InFirst=this.checked1
      this.data.ProductCost=this.checked2
     const params= JSON.parse(JSON.stringify(this.data));
     this.api.save(params).then((res) => {
          if (res.Code === 0) {
             this.$message.success("操作成功");
          } else {
            // this.tableList = TableList;
            // this.ProductModels = Product;
            this.$message.error(res.Msg);
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 400px;
}
</style>
